import { ElementState } from "@creatomate/preview";

const getOtherElementsInSameTrack = (
  activeElementsId: string[], element: ElementState, allElements: ElementState[]
): ElementState[] => (
  allElements.filter(el => el.track === element.track && !activeElementsId.includes(el.source.id))
);

export default getOtherElementsInSameTrack;
